exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.file-card{background-color:#fff;position:relative;display:flex;flex-direction:row;align-items:center;width:100%;height:79px;cursor:pointer;border-bottom:4px solid #f0f0f0}.file-card .holder{position:absolute;left:19px;bottom:14px;height:48px;width:58px}.file-card .holder .loading-indicator{position:absolute;top:calc(50% + 31px);width:100%;height:4px;left:-8px;border-radius:2px;background-color:#9b9b9b}.file-card .holder .loading-indicator .progress-indicator{position:absolute;top:0;left:0;width:0;height:4px;border-radius:2px;background-color:#184e78}.file-card .offline-icon{position:absolute;right:16px;top:27px}.file-card .image-holder{height:48px;width:48px;cursor:pointer;margin-left:16px}.file-card .image-title{line-height:22px;font-family:Open Sans,sans-serif;font-size:14px;color:#2c2c2c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:0 24px;max-width:calc(100% - 112px)}.file-card.no-border{border-bottom:none;height:62px}.file-card.dark{background-color:#f0f0f0}.file-card.uploading{cursor:default}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TaskCompletionStepsMobile/PhotoUpload/TaskCompletionStepPhotoGrid/FileCard/FileCard.scss
// module id = 1663
// module chunks = 0